/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filterpresetbw2Inputs */

const en_filterpresetbw2 = /** @type {(inputs: Filterpresetbw2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B&W`)
};

const de_filterpresetbw2 = /** @type {(inputs: Filterpresetbw2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S/W`)
};

/**
* | output |
* | --- |
* | "B&W" |
*
* @param {Filterpresetbw2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const filterpresetbw2 = /** @type {((inputs?: Filterpresetbw2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filterpresetbw2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filterpresetbw2(inputs)
	return de_filterpresetbw2(inputs)
});
export { filterpresetbw2 as "filterPresetBw" }